import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {DatePipe } from '@angular/common';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-task-report',
  templateUrl: './task-report.component.html',
  styleUrls: ['./task-report.component.scss']
})

export class TaskReportComponent implements OnInit {
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  // Variable Declaration
  displayedColumns: string[] = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT','DoneDT', 'Priority', 'Status'];
 
  dataSource = new MatTableDataSource();
  pipe = new DatePipe('en-IN');
  minDT: Date = new Date();
  maxDT: Date = new Date();
  curDate: any = new Date();
  months: any = [];
  monthDisplay: any = [];
  agencyData: any;
  jarvisData: any;
  type:any =  "MM";
  exportToExcel: any = [];
  display: string = '';
  user = {
    id: "0",
    name: ""
  };
  filterData: any = [];
  selUserData: any = [];
  tempItem: any = [];
  showDate = false;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  selectedDate: Date = new Date();
  @ViewChild('cstTable', { static: false }) cstTable!: ElementRef;
  selectedMonthName: any;
  item: any = [];
  getFullYear: any;
  filter: any;
  filterTypeID: any = 1;
  taskHistoryData:any = [];
  userList: Array<any> = [];
  userID: number = 0;

  constructor(private router: Router,  private commonService: CommonService, private apiService: APIService) { }
  view = {
    month: (this.curDate.getMonth() + 1).toString(),
    year: (this.curDate.getFullYear()).toString(),
    fy : '',
  }

  ngOnInit(): void {
    let users = this.apiService.getCookie('J');
    if(users){
      this.userList = JSON.parse(users);
      this.userID = this.userList[0].UserID;
    }

    let jarvis: any = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
        
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
 
    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.monthDisplay = this.months[this.months.length - 1].display;
    this.changeYrMonth();
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }
  
  // Month Year change
  changeYrMonth() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.view.year = selecetdYear[0].year;
    this.view.month = selecetdYear[0].number;
    this.getTasksData();
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

//export to excel
tableToExcel = (function () {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
    , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

  return function (table: any, name: string, fileName: any) {
    if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  getTasksData() {
    let data = [{
      month: this.view.month,
      year: this.view.year,
      getType: ''
    }];
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'rpt_TSK_History',
      moduleID: 28,
      data: JSON.stringify(data),
    },];
    this.apiService.getData(myParams, this.taskHistorySuccessResp.bind(this), this.taskHistoryFailureResp.bind(this));
  }

  taskHistorySuccessResp(res: any) {
  
  if (res.error) {
    
  }
  else {
    if (res) {
      var reponseData = JSON.parse(res.updatePackage);
      if (reponseData.Table[0].ErrCode == 1000) {
        alert(reponseData.Table[0].ErrMsg);
      }
      else {
        if (reponseData.Table[0].ErrCode == -1) {
          this.taskHistoryData = reponseData.Table1;
          this.taskHistoryData.forEach((element: any) => {
            element.CreatedDT = new Date(element.CreatedDT).customFormat("#DD#-#MMM#-#YY#");
            element.ExpCompletionDT = element.ExpCompletionDT ? new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#") : '';
            element.DoneDT = element.DoneDT ? new Date(element.DoneDT).customFormat("#DD#-#MMM#-#YY#") : '';
            element.Status = element.StatusID == 0 ? 'Pending' : element.StatusID == 1 ? 'Pause' : element.StatusID == 2 ? 'Cancel' : element.StatusID == 3 ? 'Done' : '';
            element.Priority = element.Priority == 0 ? 'High' : element.Priority == 1 ? 'Normal' : element.Priority == 2 ? 'Low' : '';
          });
          this.applyTaskStatusFilter(this.filterTypeID ? this.filterTypeID : 1);
        }
      }     
    }
  }
      
  }

  taskHistoryFailureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    } 
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }
    
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  clickShowDate(obj: boolean) {
    this.showDate = obj;
    if (this.showDate == true){
      this.applyTaskStatusFilter(this.filterTypeID ? this.filterTypeID : 1);
    } 
    else{
      this.changeYrMonth();
      this.selectedDate = new Date();
    }
  }

  // Selected Datewise Filter.
  fn_ChangeDate(month: number, year: number) {
    debugger
    var todayDT = new Date();
    var currentMonth = todayDT.getMonth() + 1;
    var minDate = new Date(year, month - 1, 1);
    var maxDate = new Date(year, month, 0);
    if (new Date(todayDT.getFullYear(), currentMonth, 0).customFormat('#DD#-#MMM#-#YY#') == maxDate.customFormat('#DD#-#MMM#-#YY#')) {
      maxDate = (todayDT < maxDate) ? todayDT : maxDate;
    }
    var selDT = new Date();
    if ((new Date(maxDate).customFormat('#MMM#-#YY#') == new Date(this.selectedDate).customFormat('#MMM#-#YY#'))) {
      selDT = ((new Date(this.selectedDate) < new Date(maxDate)) ? this.selectedDate : maxDate);
    }
    else {
      selDT = maxDate;
    }

    selDT = new Date(selDT);
    this.minDT = minDate;
    this.maxDT = maxDate;
    this.selectedDate = selDT;
    var copyItems = this.selUserData;
    this.tempItem = [];
    this.tempItem = copyItems.filter((x: any) => (x.CreatedDT != '' ?  new Date(x.CreatedDT).customFormat('#DD#-#MMM#-#YY#') == new Date(this.selectedDate).customFormat('#DD#-#MMM#-#YY#') : ''));
  }
  // filters
  applyTaskStatusFilter = (obj: any) => {
    // executive filter
    var copyTaskHisData = this.taskHistoryData;
    var selectedTask = copyTaskHisData.filter((x: any) => x.ToUserID == this.user.id);
    if(selectedTask.length > 0) {
      this.selUserData = selectedTask;
    }
    else if (copyTaskHisData.length != 0 && selectedTask.length == 0 && this.user.id != '0' ){
      this.selUserData = selectedTask;
    }
    else {
      this.selUserData = copyTaskHisData;
      }

    if (this.showDate == true){
      this.fn_ChangeDate(this.view.month, this.view.year)
    }
    
    // Filters - All, Open, Closed, Completed On Time, Completed Late. 
    this.filterTypeID = obj;
    this.filterData = this.showDate == true ? this.tempItem : this.selUserData;
    if (this.filterTypeID == 1) {
      this.filterData = this.filterData
      this.displayedColumns = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT', 'Priority', 'Status'];
    }
    else if (this.filterTypeID == 2) {
      this.filterData = this.filterData.filter((x: any) => x.Status != 'Done');
      this.displayedColumns = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT', 'Priority', 'Status'];
    }
    else if (this.filterTypeID == 3) {
      this.filterData = this.filterData.filter((x: any) => x.Status == "Done");
      this.displayedColumns = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT','DoneDT', 'Priority', 'Status'];
    }
    else if (this.filterTypeID == 4) {
      this.filterData = this.filterData.filter((x: any) => x.Status == "Done" && new Date(x.ExpCompletionDT) >= new Date(x.DoneDT));
      this.displayedColumns = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT','DoneDT', 'Priority', 'Status'];
    }
    else if (this.filterTypeID == 5) {
      this.filterData = this.filterData.filter((x: any) => x.Status == "Done" && new Date(x.ExpCompletionDT) < new Date(x.DoneDT));
      this.displayedColumns = ['CreatedDT', 'Task', 'ToUserName','ExpCompletionDT','DoneDT', 'Priority', 'Status'];
    } 

    this.dataSource.data = this.filterData;
    this.exportToExcel = this.filterData;
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  // common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  //export to excel
  exportToExcelTasks() { 
    var html = "";
    //Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Task History</th>"
    html += "</table></tr>"; 
    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    html += "</table></tr>";
    //header part
    if(this.user.id != '0'){
      let selectedUser = this.userList.filter((x: any) => x.UserID == this.user.id);
      html += "<p>Executive :" + selectedUser[0].Name +"</p>"
    }  
    html += "<p>Month :" + this.monthDisplay +"</p>" 
    if(this.showDate == true){
      let selectedDate = new Date(this.selectedDate).customFormat("#DD#-#MMM#-#YY#");
      html += "<p>Date:" + selectedDate + "</p>"
    }
    let filterName = ''
    if(this.filterTypeID == 1){
      filterName = "All"
    }
    else if(this.filterTypeID == 2){
      filterName = "Open"
    }
    else if(this.filterTypeID == 3){
      filterName = "Closed"
    }
    else if(this.filterTypeID == 4){
      filterName = "Completed On Time"
    }
    else if(this.filterTypeID == 5){
      filterName = "Completed Late"
    }
    html += "<p>Filter :" + filterName + "</p>"
    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Created on</th>";
    strHeader += "<th style='text-align: left;'>Tasks</th>";
    strHeader += "<th style='text-align: left;'>Executive</th>";
    strHeader += "<th style='text-align: left;'>Expected on</th>";
    if(this.filterTypeID == 3 || this.filterTypeID == 4 || this.filterTypeID == 5){
      strHeader += "<th style='text-align: left;'>Done on</th>";
    }
    strHeader += "<th style='text-align: left;'>Priority</th>";
    strHeader += "<th style='text-align: left;'>Status</th>";

    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      body += "<td style='text-align: left;'>" + item.CreatedDT + "</td>";
      body += "<td style='text-align: left;'>" +  item.Task + "</td>";
      body += "<td style='text-align: left;'>" +  item.ToUserName  + "</td>";
      body += "<td style='text-align: left;'>" + item.ExpCompletionDT + "</td>";
      if(this.filterTypeID == 3 || this.filterTypeID == 4 || this.filterTypeID == 5){
        body += "<td style='text-align: left;'>" + (item.DoneDT != '0' ? item.DoneDT : '-') + "</td>";
      }
      body += "<td style='text-align: left;'>" +  item.Priority + "</td>";
      body += "<td style='text-align: left;'>" +  item.Status + "</td>";
      body += "</tr>";
    })
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Tasks Report', 'Task History');
  }
  backBtn() {
    this.router.navigate(['/Tasks']);
 }
}